import { motion } from "framer-motion";
import {
  GraduationCap, FlaskConical, Lightbulb, Handshake, Sparkles, Briefcase, Home, Target,
} from "lucide-react";
import { WHY_CHOOSE } from "../../lib/constants";

const ICON_MAP = { GraduationCap, FlaskConical, Lightbulb, Handshake, Sparkles, Briefcase, Home, Target };

const WhyChoose = () => {
  return (
    <section id="why" className="py-20 md:py-28 bg-white" data-testid="section-why">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="text-center max-w-3xl mx-auto">
          <div className="text-xs font-semibold tracking-[0.2em] uppercase text-megha-accent">Why Choose MIETW</div>
          <h2 className="mt-2 font-heading font-extrabold text-3xl md:text-4xl lg:text-5xl tracking-tight text-megha-text">
            Built for women. Built for the future.
          </h2>
          <p className="mt-4 text-slate-600 text-base md:text-lg">
            Eight reasons why MIETW is one of the most trusted women's engineering institutions in Hyderabad.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {WHY_CHOOSE.map((w, i) => {
            const Icon = ICON_MAP[w.icon] || Sparkles;
            const isAccent = i === 1 || i === 6;
            return (
              <motion.div
                key={w.title}
                initial={{ opacity: 0, y: 22 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ delay: i * 0.05, duration: 0.5 }}
                className={`group rounded-3xl p-6 border transition-all duration-300 hover:-translate-y-1 ${
                  isAccent
                    ? "bg-megha-primary text-white border-megha-primary hover:bg-megha-accent"
                    : "bg-slate-50 border-slate-100 hover:bg-white hover:border-megha-accent/30 hover:shadow-lg hover:shadow-blue-900/5"
                }`}
                data-testid={`why-card-${i}`}
              >
                <div
                  className={`w-12 h-12 rounded-2xl flex items-center justify-center mb-4 transition-colors ${
                    isAccent ? "bg-megha-highlight text-megha-text" : "bg-megha-primary/10 text-megha-primary group-hover:bg-megha-primary group-hover:text-white"
                  }`}
                >
                  <Icon className="w-6 h-6" />
                </div>
                <div className={`font-heading font-bold text-lg ${isAccent ? "text-white" : "text-megha-text"}`}>
                  {w.title}
                </div>
                <div className={`mt-1 text-sm ${isAccent ? "text-blue-50/90" : "text-slate-500"}`}>
                  {w.desc}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
